import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FormulaColor } from '../models/formulacolor';
import { ParamsPlantilla } from '../models/paramsplantilla';
import { AppConfigService } from './config/app.config.service';

@Injectable({ providedIn: 'root' })
export class FormulaColorService {

    constructor(private http: HttpClient,
        private confServ: AppConfigService) { }

    actualizarFormulaColor(formulacolor: FormulaColor) {
        return this.http.put<FormulaColor>(`${this.confServ.getConfig().apiUrlMtto}/formulas/formulacolor`, formulacolor);
    }

    eliminarFormulaColor(idsistema: number, idformula: string, idcolor: number) {
        return this.http.delete<FormulaColor>(`${this.confServ.getConfig().apiUrlMtto}/formulas/formulacolor/sistema/${idsistema}/formula/${idformula}/color/${idcolor}`);
    }

    imprimirPreparacion(id: number): any {
        return this.http.get(`${this.confServ.getConfig().apiUrlReportes}/reportes/preparacion/${id}`, {
            responseType: 'blob'
        });
    }

    imprimirPlantilla(params: ParamsPlantilla): Observable<Blob> {
        return this.http.post(`${this.confServ.getConfig().apiUrlReportes}/reportes/plantillacarga`, params, {
            responseType: 'blob'
        });
    }

    cargarFormulas(form: FormData): Observable<any> {
        return this.http.post(`${this.confServ.getConfig().apiUrlMtto}/cargaformulas/completa`, form);
    }


}